export const STAGE_NAMES = [
  'local',
  'preview',
  'staging',
  'production',
] as const;
export type StageType = typeof STAGE_NAMES[number];

export const STAGE = process.env.STAGE as StageType;
if (STAGE && !STAGE_NAMES.includes(STAGE)) {
  throw new Error('STAGE must be one of: ' + STAGE_NAMES.join(', '));
}

export const ALLOW_ONLY_DEVELOPERS = process.env.ALLOW_ONLY_DEVELOPERS === 'true' // prettier-ignore

// OAuth
export const GITHUB_ID = process.env.GITHUB_ID ?? '';
export const GITHUB_SECRET = process.env.GITHUB_SECRET ?? '';
export const GOOGLE_ID = process.env.GOOGLE_ID ?? '';
export const GOOGLE_SECRET = process.env.GOOGLE_SECRET ?? '';

// App Settings
export const FEED_COUNT = 20;
